import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { HealthInsuranceService } from '../services/healthInsurance/health.insurance.service';
import { UsersComponent } from '../users/users.component';
import { ProviderService } from '../services/providers/provider.service';
import { Auth } from '../services/auth.service';

@Component({
  selector: 'healthInsurance',
  templateUrl: './health-insurance.component.html',
//   styleUrls: ['.//users/users.component.css']
})

export class HealthInsurancesComponent extends UsersComponent {

  name:string;
  hasSysOpsPermission:boolean = false;

  constructor(
    protected router: Router,
    protected healthInsuranceService: HealthInsuranceService,
    protected providerSevice: ProviderService,
    protected auth: Auth) { super(router, healthInsuranceService, providerSevice); }

  protected getDetailUrl(): string {

    return '/healthInsurance/' + this.selectedUser.id;
  };

  protected getUserString(): string {

    return 'healthInsurance';
  };

  protected getUsersString(): string {

    return 'healthInsurances';
  };

  async ngOnInit() {
    this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
    this.getUsers({ limit: this.usersPerGet })
  };

  alertExist:boolean=false;
  alertConfirm:boolean=false;
  closeAlertConfirm(){
    this.createCalled=false
    this.alertConfirm=false;
  }
  closeAlertExist(){
    this.createCalled=false
    this.alertExist=false;
  }

  pushOrdered(healthInsurance){
    for (let i=0;i<this.users.length;i++){
      if (healthInsurance.name.toLowerCase() < this.users[i].name.toLowerCase()){
        this.users.splice(i,0,healthInsurance)
        return;
      }
    }
    this.users.push(healthInsurance)

  }

  finishAdd(){
    this.alertConfirm=false;

    if (this.healthInsuranceExist(this.name)) {
      this.alertExist=true;
      this.createCalled=false
      return;
    }
    this.alertExist=false;
    this.healthInsuranceService.createHealthInsuranceProvider(this.name)
      .then(healthInsurance => {

        this.createCalled = false;
        this.pushOrdered(healthInsurance);
        this.selectedUser = null;
        this.alertCreated=true;
        this.configPages()
        return this;
      })
      .catch(error => {

        this.createCalled = false;
        confirm(error.message)
        return Promise.reject(error.message || error);
      });
  }
  add(): void {
    this.alertConfirm=false;
    this.alertCreated=false;
    this.alertExist=false;

    if (this.createCalled) {
      return;
    }

    if (this.name==undefined) {
      this.alertAdd=true;
      return;
    }

    this.alertAdd=false;
    this.createCalled = true;
    this.alertConfirm=true;


  }

  healthInsuranceExist(healthInsurance:string): boolean{
    for (let i=0;i<this.users.length;i++){
      if (healthInsurance.toLowerCase() === this.users[i].name) return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/health-insurances/health-insurance.component.ts